const breakpoints = [ 576, 768, 992, 1366 ];

const theme = {
    colors: {
        common: {
            white: '#FFFFFF',
            black: '#1D0B15',
            grey: '#989898'
        },
        primary: {
            main: '#CA1576',
            dark: '#A91464',
            contrastText: '#FFFFFF'
        },
        secondary: {
            main: '#E8E8E8',
            dark: '#989898',
            contrastText: '#141414'
        },
        tertiary: {
            main: '#5E464C',
            light: '#FBEFF2'
        },
        error: {
            dark: '#A91414',
            main: '#CA1515',
            light: '#E54C4C',
            lighter: '#FFDDDD',
            contrastText: '#FFFFFF'
        },
        warning: {
            dark: '#A99014',
            main: '#CAAC15',
            light: '#FFD569',
            contrastText: '#141414'
        },
        success: {
            dark: '#05532B',
            main: '#1E794B',
            light: '#64BC90',
            lighter: '#DDFFDD',
            contrastText: '#FFFFFF'
        },
        info: {
            main: '#007bff'
        }
    },
    spacing: {
        xxxs: '4px',
        xxs: '8px',
        xs: '16px',
        s: '24px',
        m: '32px',
        l: '40px',
        xl: '62px',
        xxl: '80px',
        xxxl: '106px'
    },
    borderRadius: {
        s: '4px',
        m: '8px',
        l: '16px'
    },
    mediaQuery: {
        mobileOnly: `@media (max-width: ${breakpoints[0] - 1}px)`,
        largeMobileOnly: `@media (max-width: ${breakpoints[1] - 1}px)`,
        largeMobileUp: `@media (min-width: ${breakpoints[0]}px)`,
        tabletUp: `@media (min-width: ${breakpoints[1]}px)`,
        tabletLandscapeUp: `@media (min-width: ${breakpoints[2]}px)`,
        desktopUp: `@media (min-width: ${breakpoints[3]}px)`
    },
    typography: {
        fontFamily: "'Roboto', sans-serif",
        h1: {
            fontSize: '48px',
            lineHeight: '130%',
            fontWeight: 600
        },
        h2: {
            fontSize: '32px',
            lineHeight: '130%',
            fontWeight: 600
        },
        h3: {
            fontSize: '28px',
            lineHeight: '130%',
            fontWeight: 600
        },
        h4: {
            fontSize: '24px',
            lineHeight: '130%',
            fontWeight: 600
        },
        h5: {
            fontSize: '20px',
            lineHeight: '130%',
            fontWeight: 600
        },
        h6: {
            fontSize: '18px',
            lineHeight: '150%',
            fontWeight: 500
        },
        p: {
            fontSize: '18px',
            lineHeight: '160%',
            fontWeight: 400
        },
        pBold: {
            fontSize: '18px',
            lineHeight: '160%',
            fontWeight: 600,
            opacity: 0.9
        },
        pTiny: {
            fontSize: '16px',
            lineHeight: '150%',
            fontWeight: 400,
            opacity: 0.9
        }
    },
    size: {
        headerHeight: '60px',
        footerHeight: '141.19px',
        mintWidth: '60px',
        mintHeight: '25px',
        assetWidth: '300px',
        secondaryMarketLogosWidth: '150px',
        assetWidthTiny: '240px',
        loadingHeight: '100px',
        loadingWidth: '100px',
        loadingBorder: '8px',
        gridItemButtonsWidth: '180px',
        templateWidth: '100px',
        templateHeight: '100px',
        maxContentWidth: 1500,
        dropdownWidth: '180px'
    },
    shadow: {
        dropShadow: '5px 5px 30px 2px rgba(64,64,64,0.5)',
        dropShadowGridButtons: '4px 4px 10px 4px #000000',
        dropShadowCard: '4px 4px 8px 2px #00000077'
    },
    transition: {
        default: 'all 150ms cubic-bezier(0.4, 0, 0.2, 1)'
    }
};

export default theme;
